import React from 'react'
import Skeleton from '../Skeleton'

import parcel from '../../assets/parcel.png'
import pin from '../../assets/pin.png'

const DeliverySkeleton = () => (
  <div
    style={{
      display: 'flex',
      background: 'white',
      borderRadius: 10,
      padding: 10,
      marginBottom: 10,
      boxShadow: '2px 2px 2px 2px lightgrey',
      alignItems: 'center',
      justifyContent: window.isMobile ? 'flex-start' : 'space-between',
      flexWrap: 'wrap',
    }}
  >
    <div style={{ border: '2px solid #eee', marginRight: 20, borderRadius: 7, padding: 10, fontWeight: 'bold', width: window.isMobile ? '30%' : 80, height: 80, textAlign: 'center' }} />
    <div style={{ minWidth: window.isMobile ? '30%' : 70, height: 60 }}>
      <Skeleton />
    </div>
    <div style={{ flex: 10, padding: '0 70px 0 30px', minWidth: window.isMobile ? '100%' : '30%', height: 20 }}>
      <Skeleton />
    </div>

    <div style={{ flex: 1 }} />

    <div style={{ flex: 8, minWidth: window.isMobile && '100%', display: 'flex', flexDirection: window.isMobile ? 'column' : 'row', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <img style={{ width: 28, marginBottom: 3 }} src={pin} alt="pin" />
        <div style={{ fontSize: 12, height: 20, width: 200, marginBottom: 4 }}>
          <Skeleton />
        </div>
        <div style={{ fontSize: 12, height: 20, width: 100 }}>
          <Skeleton />
        </div>
      </div>
      <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
        <img style={{ width: 28, marginBottom: 3 }} src={parcel} alt="parcel" />
        <div style={{ fontSize: 12, height: 20, width: 100, marginBottom: 4 }}>
          <Skeleton />
        </div>
        <div style={{ fontSize: 12, height: 20, width: 100 }}>
          <Skeleton />
        </div>
      </div>
      <div style={{ flex: 1, width: 160, marginTop: 0, minHeight: 40, marginBottom: 0, marginLeft: 20 }} className="sub-title-text-container" />
    </div>
  </div>
)

export default DeliverySkeleton
